/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import FormFactory from '../../components/form_factory'
import { useAlertBox, useGame } from '../../contexts'
import { t } from '../../adapters/translate/translate'
import { getTeam } from '../../utils/team_helpers'
import { makePostHelp } from '../../../main/usecases/help/post-help-factory'

const HelpForm = ({ isAnonymous, handleClose }: any) => {
  const { alertBox, closeBox } = useAlertBox()
  const [data, setData] = useState<any>(null)
  const { game } = useGame()
  const team = getTeam()

  useEffect(() => {
    const items = []

    if (isAnonymous) {
      items.push({
        name: 'name',
        title: t('Name'),
        placeholder: ' ',
        isRequired: true,
        tabIndex: 4,
        component: 'Input',
        validations: 'inputRequired',
        mb: 30,
        mt: 40
      })
      items.push({
        name: 'email',
        title: t('E-mail'),
        placeholder: ' ',
        isRequired: true,
        tabIndex: 4,
        validations: 'emailRequired',
        component: 'Input',
        type: 'email',
        mb: 30
      })
    }

    if (!game) {
      items.push({
        name: 'game',
        title: t('Game'),
        placeholder: ' ',
        tabIndex: 4,
        component: 'Input',
        mb: 30,
        col: [team ? '100%' : '50%']
      })
    }

    if (!team) {
      items.push({
        name: 'team',
        title: t('Team'),
        placeholder: ' ',
        tabIndex: 4,
        component: 'Input',
        mb: 30,
        col: [game ? '100%' : '50%']
      })
    }

    items.push({
      name: 'text',
      title: t('Message'),
      placeholder: ' ',
      isRequired: true,
      tabIndex: 5,
      validations: 'inputRequired',
      component: 'Textarea'
    })
    items.push({
      name: 'button',
      component: 'Button',
      title: t('Send'),
      submittingText: `${t('Sending')}...`
    })

    setData([{ name: 'help', items }])
  }, [])

  const handleSubmit = async (values: any) => {
    try {
      await makePostHelp().post({
        message: {
          ...values,
          game: game ? game.name : values.game,
          team: team ? team.name : values.team,
          gameUuid: game ? game.uuid : null
        }
      })
      alertBox(t('Your message was sent. We will reply to you by e-mail shortly.'), [{
        title: t('OK'),
        action: () => {
          handleClose()
          closeBox()
        }
      }])
    } catch (error: any) {
      alertBox(t(error?.code, error?.message))
    }
  }

  return (
    data && <FormFactory data={data} onSubmit={handleSubmit} />
  )
}

export default HelpForm
